<template>
<v-card class="pa-3">
    <v-layout row wrap align-baseline mb-5>
        <v-flex xs12 md8>
            <h4 class="title">
                {{teacher.first_name}} {{teacher.last_name}}
            </h4>
        </v-flex>
        <v-flex xs12 md4>
            <v-select :items="semesters" item-value="name" item-text="name" label="Choose Semester" v-model="chosenSemester">
            </v-select>
        </v-flex>
    </v-layout>

    <v-data-table :headers="headers" :items="courses" hide-actions style="margin-bottom: 2rem;">
        <template slot="items" slot-scope="props">
            <tr>
                <td>{{ props.item.section }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.grade }}</td>
                <td class="text-xs-center">{{ props.item.days }}</td>
                <td class="text-xs-center">{{ props.item.period }}</td>
                <td class="text-xs-center">{{ props.item.current_seats }} / {{ props.item.max_seats }}</td>
                <td class="text-xs-center">{{ props.item.wait_list }} </td>
            </tr>
        </template>
    </v-data-table>

    <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn color="blue white--text" small @click="close">Close</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
export default {
    props: ['teacher', 'active'],
    data() {
        return {
            chosenSemester: '',
            headers: [{
                    text: 'Section',
                    align: 'left',
                    value: 'section',
                    width: '10%'
                },
                {
                    text: 'Name',
                    align: 'left',
                    value: 'name',
                    width: '20%'
                },
                {
                    text: 'Grade',
                    align: 'left',
                    value: 'grade',
                    width: '10%'
                },
                {
                    text: 'Day',
                    align: 'center',
                    value: 'days',
                    width: '5%'
                },
                {
                    text: 'Period',
                    align: 'center',
                    value: 'period',
                    width: '5%'
                },
                {
                    text: 'Enrolled',
                    align: 'center',
                    value: '',
                    width: '10%'
                },
                {
                    text: 'Waitlist',
                    align: 'center',
                    value: '',
                    width: '10%'
                },
            ]
        }
    },
    computed: {
        semesters() {
            return this.$store.state.semesterModule.semesters
        },
        courses() {
            if (this.teacher.courses) {
                return this.teacher.courses.filter(c => c.semester === this.chosenSemester)
            }
        }
    },
    watch: {
        'active': function (value) {
            if (!value) {
                this.chosenSemester = ''
            }
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>
